import { useRef, useEffect } from 'react'

import { Props as SelectProps, StylesConfig } from 'react-select'
import { useField } from '@unform/core'

import { InputError, Select, SelectContainer } from './style'

interface ISelectProps extends SelectProps {
  name: string
  icon?: string
  placeholder?: string
  disabled?: boolean
  value?: any
  small?: boolean
  xsmall?: boolean
  large?: boolean
  marginRight?: number
  initError?: string
}

interface ColourOption {
  readonly isDisabled?: boolean
}

export default function SelectComponent(props: ISelectProps) {
  const { name, placeholder, isMulti, disabled, small, initError } = props
  const {
    defaultValue: _defaultValue,
    onChange: _onChange,
    ...inputErrorProps
  } = props
  const selectRef: any = useRef<HTMLSelectElement>(null)
  const { fieldName, defaultValue, registerField, error } = useField(name)

  const colourStyles: StylesConfig<ColourOption> = {
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#cdcac5 !important' : '#fbfbfb',
        color: isSelected ? '#ffffff !important' : '#9c948c',
        padding: '5px',
      }
    },
    menuList: (base) => ({
      ...base,
      width: small ? '160px' : '325px',
      '::-webkit-scrollbar': {
        width: '8px',
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
      '::-webkit-scrollbar-track': {
        background: '#fbfbfb',
        border: 0,
      },
      '::-webkit-scrollbar-thumb': {
        width: '8px',
        backgroundColor: '#C4C4C4',
        borderRadius: '50px',
      },
    }),
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (isMulti) {
          if (!ref.state.selectValue) {
            return []
          }
          return ref.state.selectValue.map((option: any) => option.value)
        }
        if (!ref.state.selectValue[0]) {
          return ''
        }
        return ref.state.selectValue[0].value
      },
    })
  }, [fieldName, registerField, isMulti])

  return (
    <SelectContainer>
      <Select
        placeholder={placeholder || 'Selecione...'}
        defaultValue={defaultValue}
        ref={selectRef}
        classNamePrefix="Select"
        error={error || initError}
        styles={colourStyles}
        isDisabled={disabled}
        // value={disabled && ''}
        {...props}
      />
      <InputError {...inputErrorProps}>{error}</InputError>
    </SelectContainer>
  )
}
